import React from "react";

const VERSION = "v6";
const SRC = {
  hello: `/joki/joki-hello.png?${VERSION}`,
  study: `/joki/joki-study.png?${VERSION}`,
  wink: `/joki/joki-wink.png?${VERSION}`,
};

/**
 * Mascotte Joki — wallaby blanc/orange/rose du Lycée Joseph Wresinski.
 * Props :
 *  - pose : "hello" | "study" | "wink" (défaut "wink")
 *  - size : largeur CSS (px ou unités tailwind via className)
 *  - className : classes Tailwind additionnelles
 *  - alt : texte alternatif accessible
 *  - float : si true, applique une légère animation de flottement
 */
export const Joki = ({ pose = "wink", size = 96, className = "", alt = "Joki, la mascotte du lycée", float = false }) => {
  const animClass = float ? "joki-float" : "";
  return (
    <img
      src={SRC[pose] || SRC.wink}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      draggable={false}
      data-testid={`joki-${pose}`}
      className={`select-none ${animClass} ${className}`}
      style={{ width: typeof size === "number" ? `${size}px` : size, height: "auto" }}
    />
  );
};

export default Joki;
